/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Billing/Enum/InvoiceLocale.php */
export const invoiceLocale = {
	'en-GB': 'en-GB',
	'de-DE': 'de-DE',
	'fi-FI': 'fi-FI',
} as const

/** @see backend/nexus/modules/Billing/Enum/InvoiceLocale.php */
export type InvoiceLocale = (typeof invoiceLocale)[keyof typeof invoiceLocale]
